import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { Tenant } from "../interfaces/Tenant";

const api = new APIClient();

/**
 * Get tenant details by ID
 * @param id - Tenant UUID
 * @returns Promise<Tenant>
 */
export const getTenantById = async (id: string): Promise<Tenant> => {
    return api.get<Tenant>(`${url.GET_TENANT_BY_ID}/${id}`, {});
};
